module.exports = __webpack_public_path__ + "static/media/b18.ae76b926.svg";